(function($) {

// Use this variable to set up the common and page specific functions. If you
// rename this variable, you will also need to rename the namespace below.
var Roots = {
	// All pages
	common: {
		init: function() {
			$('body').removeClass('no-js');

			$('[placeholder]').not( ".jet" ).focus(function() {
				var input = $(this);
				if (input.val() === input.attr('placeholder')) {
					input.val('');
					input.removeClass('placeholder');
				}
			}).blur(function() {
				var input = $(this);
				if (input.val() === '' || input.val() === input.attr('placeholder')) {
					input.addClass('placeholder');
					input.val(input.attr('placeholder'));
				}
			}).blur();
			$('[placeholder]').not( ".jet" ).parents('form').submit(function() {
				$(this).find('[placeholder]').each(function() {
					var input = $(this);
					if (input.val() === input.attr('placeholder')) {
						input.val('');
					}
				});
			});

			var $selects = $('select.gfield_select');
			$selects.easyDropDown();

			$('#masthead').waypoint('sticky', {
				offset: -60,
				wrapper: '<div class="sticky-masthead" />'
			});

			$("#mobile-navigation").html( $("#site-navigation").html() );

			$("#nav-trigger span").click(function(){
				if ($("nav#mobile-navigation ul").hasClass("expanded")) {
					$("nav#mobile-navigation ul.expanded").removeClass("expanded").slideUp(250);
					$(this).removeClass("open");
				} else {
					$("nav#mobile-navigation ul").addClass("expanded").slideDown(250);
					$(this).addClass("open");
				}
			});
		}
	},
	// Home page
	home: {
		init: function() {
			// JavaScript to be fired on the home page
		}
	},
	// About us page, note the change from about-us to about_us.
	about_us: {
		init: function() {
			// JavaScript to be fired on the about us page
		}
	},
	// Opportunity Search
	opportunity_search: {
		init: function() {
			mapWidth();
			$(window).resize(mapWidth);

		    var mapActive = false;
			$( ".button.map" ).click(function(e) {
				e.preventDefault();
				if(mapActive===false) {
					mapActive = true;
					$(this).addClass('active');
					$('#map-row').addClass('active');
					var ww = $(window).width();
					var mapPadding = '30%';
					if (ww < 500) {
						mapPadding = '80%';
					}
					$('#map-row').velocity({
						paddingBottom: mapPadding
					},{
						duration: 500,
						easing: "easeInSine",
						complete: function() {
							new Maplace({
								map_div : '#map-row .map',
								locations: LocsJobs,
						        controls_on_map: false,
						        map_options: {
						        	maxZoom: 12,
						        	streetViewControl: false,
									styles: [{"featureType":"all","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"hue":"#EC6728"},{"saturation":100},{"lightness":-3}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#74C9E3"},{"hue":"#74C9E3"},{"saturation":100},{"lightness":-3}]}]
						        }
						    }).Load();
						}
					});
				} else {
					$('#map-row').velocity({
						paddingBottom: '0%'
					},
					{
						duration: 500,
						easing: "easeInSine",
						complete: function() {
							mapActive = false;
							$('.button.map').removeClass('active');
							$('.nav-menu').removeClass('active');
							$('#map-row').removeClass('active');
						}
					});
				}
			});
		}
	},
	// Job Page
	job: {
		init: function() {
			if (!$('html').hasClass("lt-ie9")) {
				stickyintro();
			}

			mapWidth();
			$(window).resize(mapWidth);

		    var mapActive = false;
			$( ".mapview" ).click(function(e) {
				e.preventDefault();
				if(mapActive===false) {
					mapActive = true;
					$(this).addClass('active');
					$('.secondary .inner').addClass('map-active');
					$('#map-row').addClass('active');
					var ww = $(window).width();
					var mapPadding = '30%';
					if (ww < 500) {
						mapPadding = '80%';
					}
					$('#map-row').velocity({
						paddingBottom: mapPadding
					},{
						duration: 500,
						easing: "easeInSine",
						complete: function() {
							new Maplace({
								map_div : '#map-row .map',
								locations: LocsJobs,
								generate_controls: false,
						        controls_on_map: false,
						        map_options: {
						        	zoom: 12,
						        	maxZoom: 12,
						        	streetViewControl: false,
						        	zoomControl: false,
						        	scrollwheel: false,
									styles: [{"featureType":"all","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"hue":"#EC6728"},{"saturation":100},{"lightness":-3}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#74C9E3"},{"hue":"#74C9E3"},{"saturation":100},{"lightness":-3}]}]
						        }
						    }).Load();
						    $('.sub-nav').velocity("scroll", { duration: 500, easing: "easeInSine" });
						}
					});
				} else {
					$('#map-row').velocity({
						paddingBottom: '0%'
					},
					{
						duration: 500,
						easing: "easeInSine",
						complete: function() {
							mapActive = false;
							$('.nav-menu').removeClass('active');
							$('.secondary .inner').removeClass('map-active');
							$('#map-row').removeClass('active');
						}
					});
				}
			});

		}
	},
	// Service Page
	page_template_template_faqs_php: {
		init: function() {
		$(".faq-row a.button").click(function () {
			var $this = $(this);
			$this.prev("div.a").slideToggle(200, function() {
				$this.text($(this).is(':visible') ? "Close": "Read more");
			});
		});
		}
	},
	// Contact Page
	page_template_template_contact_php: {
		init: function() {
			new Maplace({
				map_div : '.map-box .map',
				locations: LocStep,
		        controls_on_map: false,
		        map_options: {
					zoom: 12,
					styles: [{"featureType":"all","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"saturation":-100},{"lightness":50}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#74C9E3"},{"hue":"#74C9E3"},{"saturation":100},{"lightness":-3}]}]
		        }
		    }).Load();
		}
	},
	// Client Page
	single_client_pages : {
		init: function () {
			var job_options = {
				valueNames: [ 'job-title' ],
				listClass: 'jobs-list',
				searchClass: 'search-job-titles'
			};

			var jobList = new List('jobs', job_options);

			$( '#jobs .interview' ).click(function() {
				minAjax({
					url: adminUrl,
					type:"GET",
					data:{
						action:"request_interview",
						shortlistid:$(this).data('shortlistid'),
						vacancyid:$(this).data('vacancyid')
					},
					method:"true",
					debugLog:"true",
					success: function(data){
						console.log(data);
						location.reload();
					}
				});
			});
		},
		finalize: function() {
			var jets = new Jets({
				searchTag: '.search-job-applicants',
				contentTag: '.jobs-list .list'
			});

			$('.search-job-applicants').val();

			jets.update();
		}
	},
	// Client Login
	client_login : {
		init: function () {
			$('#user_login').attr( 'placeholder', 'Email' );
			$('#user_pass').attr( 'placeholder', 'Password' );
		}
	},
	// Candidate Page
	single_applicant_pages : {
		init: function () {

			$('.skip-button a').click(function(e) {
				console.log($(this).attr('href'));
				$($(this).attr('href')).velocity("scroll", {
					offset: -170
				});
				$($(this).attr('href')).velocity("callout.tada");
			});

			$( '#interview' ).click(function() {
				minAjax({
					url: adminUrl,
					type:"GET",
					data:{
						action:"request_interview",
						shortlistid:$(this).data('shortlistid'),
						vacancyid:$(this).data('vacancyid')
					},
					method:"true",
					debugLog:"true",
					success: function(data){
						console.log(data);
						location.reload();
					}
				});
			});

			$( '#reject' ).click(function() {
				minAjax({
					url: adminUrl,
					type:"GET",
					data:{
						action:"reject_candidate",
						shortlistid:$(this).data('shortlistid'),
						vacancyid:$(this).data('vacancyid')
					},
					method:"true",
					debugLog:"true",
					success: function(data){
						console.log(data);
						location.reload();
					}
				});
			});
		},
		finalize: function() {
			var jets = new Jets({
				searchTag: '.search-skills',
				contentTag: '.skill-set .level'
			});
		}
	},
};

// The routing fires all common scripts, followed by the page specific scripts.
// Add additional events for more control over timing e.g. a finalize event
	var UTIL = {
		fire: function(func, funcname, args) {
			var fire;
			var namespace = Roots;
			funcname = (funcname === undefined) ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === 'function';

			if (fire) {
				namespace[func][funcname](args);
			}
		},
		loadEvents: function() {
			// Fire common init JS
			UTIL.fire('common');

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
				UTIL.fire(classnm);
				UTIL.fire(classnm, 'finalize');
			});

			// Fire common finalize JS
			UTIL.fire('common', 'finalize');
		}
	};


	$(document).ready(UTIL.loadEvents);

function stickyintro() {
	var ww = $(window).width();
	if (ww > 1024) {
		var resultsMap = $('.job.page .secondary .inner'),
			mapContainer = $('.job.page div.entry-content'),
			mapPosition = resultsMap.position().top,
			thisWindow = $(window),
			mapOffset = resultsMap.offset(),
			mapWidth = resultsMap.outerWidth(true),
			topMargin = 100,
			footerOffestTop = $('.entry-footer').height() + $('.second-footer').height() + $('#colophon').height();

			thisWindow.scroll(function() {
			if ($(document).scrollTop() > mapOffset.top - 100) {

				var destinationOffset = $(document).scrollTop() - mapOffset.top + topMargin;

				if (destinationOffset < (mapContainer.height() - resultsMap.height())) {
					if ((($(document).scrollTop() - mapOffset.top + topMargin) + resultsMap.height()) < mapContainer.height()) {
						resultsMap.stop().css({
							'top': $(document).scrollTop() - mapOffset.top + topMargin
						});
					} else {
						resultsMap.stop().css({
							'top': $(document).scrollTop() - mapOffset.top + topMargin - ((($(document).scrollTop() - mapOffset.top + topMargin) + resultsMap.height()) - mapContainer.height() )
						});
					}
				} else {
					resultsMap.stop().css({
						'top': footerOffestTop - topMargin - (((footerOffestTop - topMargin) + resultsMap.height()) - mapContainer.height())
					});
				}
			} else {
				if (resultsMap.height() > $(document).scrollTop()) {
					resultsMap.stop().css({
						'top': mapPosition
					});
				}
			}
		});
	}
}

function mapWidth() {
	var vpw = $(window).width();
	var cw = $('.entry-content').width();
	$('#map-row .map-container').css({'width': vpw + 'px','left': -((vpw-cw)/2) + 'px'});
}


})(jQuery); // Fully reference jQuery after this point.
